var _circle, _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHealthcare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#FBEFF7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.416,
    y: 14.084,
    width: 15.167,
    height: 15.167,
    rx: 1.25,
    stroke: "#CD676F",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.667h5M20 24.167v-5M13.333 10.834h13.333",
    stroke: "#CD676F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjIwIiBmaWxsPSIjRkJFRkY3Ii8+CiAgICAgICAgICAgICAgICA8cmVjdCB4PSIxMi40MTY1IiB5PSIxNC4wODM1IiB3aWR0aD0iMTUuMTY2NyIgaGVpZ2h0PSIxNS4xNjY3IiByeD0iMS4yNSIgc3Ryb2tlPSIjQ0Q2NzZGIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTE3LjUgMjEuNjY3SDIyLjUiIHN0cm9rZT0iI0NENjc2RiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTIwIDI0LjE2N0wyMCAxOS4xNjciIHN0cm9rZT0iI0NENjc2RiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTEzLjMzMyAxMC44MzM1SDI2LjY2NjMiIHN0cm9rZT0iI0NENjc2RiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgICAgICAgICAgICAgPC9zdmc+";
export { SvgHealthcare as ReactComponent };